/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(props) {
  delete props.display;
  delete props.shouldComponentUpdate;
  delete props.wrap;
  delete props.row;
  delete props.column;
  delete props.alignItems;
  delete props.alignSelf;
  delete props.alignContent;
  delete props.justifyContent;
  delete props.flex;
  delete props.flexGrow;
  delete props.flexFlow;
  delete props.flexShrink;
  delete props.flexBasis;
  delete props.inline;
  delete props.wrap;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Flex/src/cleanup.js
// module id = 245
// module chunks = 0